import { fetchAuthSession } from "aws-amplify/auth";
import { post, put, del } from "aws-amplify/api";
import { useMutation, useQueryClient } from "react-query";
import { SYMPTOMS_QUERY_KEY } from "./useSymptomsQuery";

export const useSymptomsPostMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (symptomFormInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: "hrsymptomsapi",
        path: `/symptoms`,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: symptomFormInputs,
        },
      }).response;
      return (await body?.json()) || {};
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [ SYMPTOMS_QUERY_KEY] });
    },
  });
};

export const useSymptomsPutMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (symptomFormInputs) => {
      const session = await fetchAuthSession();
      const { body } = await put({
        apiName: "hrsymptomsapi",
        path: "/symptoms",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: symptomFormInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [SYMPTOMS_QUERY_KEY] });
    },
  });
};

export const useSymptomsDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const session = await fetchAuthSession();
      const { body } = await del({
        apiName: "hrsymptomsapi",
        path: "/symptoms",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          queryParams: { id: id },
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [SYMPTOMS_QUERY_KEY] });
    },
  });
};
